<ng-container>
  @if (currentCartId) {
    <div class="mini-cart__actions">
      <div class="mini-cart__name">
        @if (usersCarts?.length === 1) {
          <h5 class="current-cart-name">
            {{ currentCartName }}
          </h5>
        }
        @if (usersCarts?.length > 1) {
          <app-dropdown [dropDownName]="'miniCart-name'">
            <ng-container ngProjectAs="[slot][toggle]">
              <button class="button button--link mini-cart__btn-name">
                <h5>{{ currentCartName }}</h5>
                <span class="icon-arrow-down"></span>
              </button>
            </ng-container>
            <ng-container ngProjectAs="[slot][panel]">
              <ng-container>
                @for (cart of usersCarts; track cart.id) {
                  <span
                      class="menu__item"
                      [ngClass]="{'hidden': hiddenUsersCarts(cart, currentCartId) }"
                      (click)="switchDefaultCart(cart.id)">
                    {{ cart.name }}
                  </span>
                }
              </ng-container>
            </ng-container>
          </app-dropdown>
        }
      </div>
      <div class="mini-cart__settings">
        <app-dropdown [dropDownName]="'miniCart-settings'">
          <ng-container ngProjectAs="[slot][toggle]">
            <button class="button button--link mini-cart__btn-settings">
              <h5>{{ 'mini-cart.cart-settings' | translate }}</h5>
              <span class="icon-arrow-down"></span>
            </button>
          </ng-container>
          <ng-container ngProjectAs="[slot][panel]">
            <span class="menu__item" (click)="showAddNicknameModalEmit()">
              {{ getAddOrEditNicknameLabel() | translate }}
            </span>
            <span class="menu__item" (click)="showDeleteCartModalEmit()">
              {{ 'mini-cart.delete-cart' | translate }}
            </span>
          </ng-container>
        </app-dropdown>
      </div>
    </div>
  }
  @if (itemsInCart?.length > 0) {
    <div class="mini-cart__items">
      <div class="overflow-gradient"></div>
      <div class="items-list">
        @for (item of itemsInCart; track $index; let index = $index) {
          <div class="item-row" [attr.data-test]="'minicart-item-' + item.attributes.name">
            <div class="item-col-img">
              <img [src]="getItemPicture(item)" [alt]="item.attributes.name">
            </div>
            <div class="item-col-desc" [attr.data-test]="'desc-minicartItemName-'+item.attributes.name">
              <a [routerLink]="['/product/', item.attributes.abstractSku]" (click)="closeMiniCartAfterClickOnLink()">
                {{ item.attributes.name || item.attributes.attributes?.sap_name }}</a><br>
              <small>{{ item.attributes.materialNumber || item.attributes.attributes?.sap_material_number }}</small>
            </div>
            <div class="item-col-qty" [attr.data-test]="'desc-minicartItemQuantity-'+item.attributes.name">
              <form (submit)="updateCartItemQuantityEmit(item.attributes.quantity, itemQuantity.value, item, index)">
                <input #itemQuantity
                    [attr.data-test]="'desc-minicartItemQuantityInput-' + item.attributes.name"
                    type="number"
                    name="itemQuantity"
                    class="item-quantity"
                    [value]="item.attributes.quantity"
                    [min]="1"
                    step="1"
                    required
                    (change)="updateCartItemQuantityEmit(item.attributes.quantity, itemQuantity.value, item, index)"/>
              </form>
            </div>
            @if (!!item.attributes?.calculations?.unitPrice && checkWorkflowInformation) {
              <div class="item-col-price" [attr.data-test]="'desc-minicartItemPrice-'+item.attributes.name">
                {{ item.attributes.calculations.unitPrice | currency:currency }}
                @if (isExcludeTaxActive) {
                  <span class="tax-disclaimer" [attr.data-test]="'desc-taxDisclaimer'">
                    ({{ 'app-product-page.ex_gst' | translate }})
                  </span>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
</ng-container>
